import loadCookieConsentModule from './modules/CookieConsent.module';
import loadCustomerModule from './modules/Customer.module';
import loadSessionModule from './modules/Session.module';
const loadAccountProfileDetailsModule = () => ({
    hasRouter: true,
    modules: [loadSessionModule(), loadCustomerModule(), loadCookieConsentModule()],
});
export default loadAccountProfileDetailsModule;
